export const OPEN_CALL_MODAL = 'page/OPEN_CALL_MODAL';
export const CLOSE_CALL_MODAL = 'page/CLOSE_CALL_MODAL';
export const OPEN_MENU = 'page/OPEN_MENU';
export const CLOSE_MENU = 'page/CLOSE_MENU';
export const TOGGLE_MENU = 'page/TOGGLE_MENU';
